import React from 'react';
import {injectStripe, CardElement} from 'react-stripe-elements';
import Button from '../common/components/button/Button';
import withLocalized from 'modules/localization/withLocalized'

import './CheckoutForm.css';

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: 'inherit',
      },
    },
  };
};

class CheckoutForm extends React.Component {

  state = {
    loading: false,
    complete: false,
    failed: false,
    failreason: "",
  }

  handleChange = ({complete}) => {
    this.setState({
      complete
    })
  }

   handleSubmit = async (ev) => {
    ev.preventDefault()

    this.setState({loading: true, failed: false, failreason: ""})
  
    const { client_secret, user, onSuccess } = this.props

    const {
      paymentIntent,
      error
    } = await this.props.stripe.handleCardPayment(client_secret, {
      payment_method_data: {
        billing_details: {
          email: user.email
        }
      }
    })

    if (error) {
      this.setState({
        loading: false,
        complete: false,
        failed: true,
        failreason: error.message
      })
    } else {
      onSuccess(paymentIntent)
    }
  };

  render() {
    const { loading, complete, failed, failreason } = this.state
    const { loading: parentLoading, localized } = this.props
    return (
      <form className="Stripe-form">
        <div style={{marginBottom: '1rem'}}>
          <CardElement
            onChange={this.handleChange}
            onReady={(el) => el.focus()}
            {...createOptions()}
          />
        </div>
          { failed && <p style={{color: "#ED5564"}}>{failreason} </p>}
          <Button onClick={this.handleSubmit} block type="submit" disabled={loading || parentLoading || !complete} loading={loading || parentLoading}>
            {localized("booking.form.submit")}
          </Button>
      </form>
    );
  }
}

export default injectStripe(withLocalized(CheckoutForm));



// WEBPACK FOOTER //
// ./src/modules/booking/CheckoutForm.js